<template>
  <div class="travel-insurance-page">
    <V2TemplatesTravelInsuranceLandingPage />
  </div>
</template>

<script setup>

const trustpilotStore = useTrustpilotStore()

const $route = useRoute()

defineOptions({
  name: 'TravelInsurancePage'
})

const { $tracking } = useNuxtApp()

onMounted(() => {
  $tracking.customEvent('travel_insurance_quote_start', {})
})

const PAGE_DETAILS = {
  title: 'Compare Travel Insurance Australia | Compare Club',
  description: 'Compare Travel Insurance in Australia with Compare Club. Quickly filter through policies to find the cover you need at a price you\'ll like',
  ogUrl: trailingSlash(`${CC_DOMAIN}${$route.path}`),
  ogType: 'product'
}

generateMeta({
  title: PAGE_DETAILS.title,
  ogTitle: PAGE_DETAILS.title,
  description: PAGE_DETAILS.description,
  ogDescription: PAGE_DETAILS.description,
  ogUrl: PAGE_DETAILS.ogUrl,
  ogType: PAGE_DETAILS.ogType
}, pageIsFunnel($route))

useJsonld(() => {
  const _path = trailingSlash($route.path)

  const {
    trustScore,
    numberOfReviews
  } = trustpilotStore.trustpilotData ?? {}

  return {
    '@context': 'https://schema.org',
    '@graph': [
      GENERATE_WEBPAGE_SCHEMA({
        page: _path,
        pageTitle: PAGE_DETAILS.title,
        pageDescription: PAGE_DETAILS.description,
        aboutPath: `${_path}#service`,
        mainEntityPath: `${_path}#service`,
        primaryImageOfPagePath: '/#logo',
        breadcrumbPath: `${_path}#breadcrumb`
      }),
      GENERATE_SERVICE_SCHEMA({
        page: _path,
        name: PAGE_DETAILS.title,
        serviceType: 'Insurance comparison',
        description: 'Compare Club are currently working with new travel insurance partners to access better value for Aussie drivers. Until then to access an insurer today, click here. Thanks for finding us, and we\'ll have an update for you next month.',
        audienceName: 'Australian consumers comparing travel insurance',
        servicePhone: '+611300757819',
        trustpilot: {
          rating: trustScore,
          count: numberOfReviews?.total
        }
      }),
      GENERATE_BREADCRUMB_SCHEMA(_path)
    ]
  }
})
</script>
